import '@babel/polyfill'

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store/store';
import axios from 'axios';
import * as VueGoogleMaps from 'vue2-google-maps';
import './registerServiceWorker';
import 'slick-carousel';
import './assets/js/script';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import messages from './i18n/index';

import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal';

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faCheck, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { fab } from '@fortawesome/free-brands-svg-icons';

Vue.use(VModal, { dialog: true });

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_ROOT_MAPS_API,
        libraries: 'visualization', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },
});

Vue.use(Vuelidate);

// library.add(faCheck, faChevronLeft);

// Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'pt-pt', // set locale
    messages, // set locale messages
});

// const DEV = false;

/*if (true) {
  axios.defaults.baseURL = 'http://localhost:8083/';
  Vue.prototype.$snqtbserver = 'http://localhost:8083/';
} else {
  axios.defaults.baseURL = 'http://snqtb.jbaysolutions.com/';
  Vue.prototype.$snqtbserver = 'http://snqtb.jbaysolutions.com/';
}*/

Vue.prototype.$axios = axios;

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
